module.exports = __webpack_public_path__ + "static/media/seta.cad69f54.svg";